export default __webpack_public_path__ + "static/DEADJIM-b277d670ca9742c5ef2e254997461056.otf";